module.exports = __webpack_public_path__ + "assets/grass-footer.c69e4b43.svg";